import React from "react";

const Footer = () => (
  <div className="footer">
    <p>Let us know your thoughts!</p>
    <div className="footer-button">
        <a href="mailto:eat-well@gmail.com" className="email-link">Contact Us 📩</a>
  </div>
  </div>
);

export default Footer;